export const Spacer = (props: { size: number }) => <div style={{ height: props.size }}></div>;
